/**
 * UI module constants — DOM ids, keys, timings, copy. Owned by UI.
 */

// --- DOM hooks (frozen ids from index.html) --------------------------------
export const UI_ROOT_ID = 'ui-root'
export const TITLE_CARD_ID = 'title-card'
/** index.html's frozen hide class for #title-card. */
export const TITLE_HIDDEN_CLASS = 'hidden'
/** UI-owned hide class for elements inside #ui-root. */
export const HIDDEN_CLASS = 'gum-hidden'

// --- Keys -------------------------------------------------------------------
export const JOURNAL_KEY = 'Tab'
export const CLOSE_KEY = 'Escape'

// --- Monologue typewriter ----------------------------------------------------
/** Fastest per-character reveal, ms. */
export const TYPE_MIN_CHAR_MS = 18
/** Slowest per-character reveal, ms. */
export const TYPE_MAX_CHAR_MS = 60
/** Fraction of the beat duration the reveal may occupy. */
export const TYPE_PORTION_OF_BEAT = 0.7
/** If AUDIO never emits monologue:done, self-hide after duration + grace. */
export const MONOLOGUE_FALLBACK_GRACE_MS = 1500

// --- HUD ----------------------------------------------------------------------
export const TOAST_DURATION_MS = 2800
/** Seconds between crosshair raycast checks. */
export const CROSSHAIR_CHECK_INTERVAL_S = 0.08
/** Matches PLAYER's interact reach (CONTRACTS.md, ~2.5 m). */
export const INTERACT_RANGE_M = 2.5
/** Radius written onto UI-built accuse InteractTargets. */
export const ACCUSE_TARGET_RADIUS_M = 1.5
/** id prefix for UI-built accuse InteractTargets (per CONTRACTS.md). */
export const ACCUSE_ID_PREFIX = 'accuse:'
/** Interact targets matching this open the accuse panel (phone booth). */
export const PHONE_TARGET_PATTERN = /phone|booth/i

// --- Copy ----------------------------------------------------------------------
export const TITLE_OVERLINE = 'A FILM NOIR INVESTIGATION'
export const TITLE_NAME = 'GUMSHOE'
export const TITLE_TAGLINE_POINTER = 'CLICK TO BEGIN — A RAIN-SOAKED CASE'
export const TITLE_TAGLINE_TOUCH = 'TAP TO BEGIN — A RAIN-SOAKED CASE'
export const INTERACT_PROMPT_POINTER = 'E — EXAMINE'
export const INTERACT_PROMPT_TOUCH = 'TAP — EXAMINE'
/** Touch-only journal button (Tab has no thumb equivalent). */
export const TOUCH_JOURNAL_BUTTON_ID = 'gum-touch-journal'
export const TOUCH_JOURNAL_LABEL = 'CASE FILE'
export const ZONE_LABEL_OUTDOOR = 'THE STREET'
export const ZONE_LABEL_INDOOR = 'THE OFFICE'
export const TOAST_PREFIX = 'EVIDENCE — '
export const JOURNAL_TITLE = 'CASE FILE'
export const JOURNAL_CLUES_HEADING = 'EVIDENCE'
export const JOURNAL_SUSPECTS_HEADING = 'SUSPECTS'
export const JOURNAL_EMPTY_CLUES = 'No evidence yet. Walk the street. Look closer.'
export const JOURNAL_EMPTY_SUSPECTS = 'Nobody in the frame yet.'
export const JOURNAL_FOOTER_HINT = 'TAB — CLOSE · FIND THE PHONE BOOTH TO MAKE THE CALL'
export const ACCUSE_TITLE = 'MAKE THE CALL'
export const ACCUSE_SUBTITLE = 'The line crackles. Give the precinct a name.'
export const ACCUSE_EMPTY = "You've got nothing to go on. Hang up and find some evidence."
export const ACCUSE_BUTTON_LABEL = 'ACCUSE'
export const ACCUSE_CLOSE_LABEL = 'HANG UP'
export const WIN_STAMP = 'CASE CLOSED'
export const LOSE_STAMP = 'CASE COLD'
export const WIN_HEADLINE_SUFFIX = ' TAKES THE FALL'
export const LOSE_HEADLINE_SUFFIX = ' WALKS FREE'
export const WIN_SUBTEXT = 'The city sleeps a little easier tonight. You light one for the road.'
export const LOSE_SUBTEXT = 'The trail went cold. Some nights, the rain wins.'
